import { KolumnaEwidencjiFiltrowanie } from "../ewidencja/kolumnaEwidencjiFiltrowanie";

export class PobierzNiedoboryLokalizacjiFiltry {
    kolumnyFiltrowania: Array<KolumnaEwidencjiFiltrowanie> = new Array();
    idLokalizacji: string;
}